import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { CostCenterList } from "@msuite/utils/types";
import { client } from "@/hono";
import { useCitadel } from "@/hooks/use-citadel";

export function useCostCenters() {
	/** Hooks */
	const { citadel } = useCitadel();

	/** Query */
	// Read through `read IncomingInvoice`, as the route; waiting for the rule spares a caller
	// without it the 403 toast.
	const query = useQuery({
		queryKey: ["cost-centers"],
		enabled: citadel?.can("read", "IncomingInvoice") === true,
		queryFn: async () => {
			const response = await client.cost_centers.index.$get();
			const data = await responseHandler(response);
			return data.costCenters as CostCenterList;
		},
	});

	/** Return */
	return { ...query, costCenters: query.data ?? [] };
}
